import { css } from 'styled-components';
import { CONF_KEY } from '../defaultConfig.js';
import { getConfig, generateMediaString, generateMediaStringBetween } from './lib.js';

const spacing = (space, preTheme) => {
  if (preTheme) {
    return `${space * getConfig(preTheme).baseSpacing}rem`;
  }
  return ({
    theme
  }) => `${space * getConfig(theme).baseSpacing}rem`;
};
const getScreenSize = theme => {
  let viewport = null;
  let newScreenSize = 'xxl';
  const confKey = theme[CONF_KEY];
  if (!confKey) throw new Error('Theme must be a grid config theme.');
  if (window?.innerWidth) {
    viewport = window.innerWidth;
  }
  if (viewport) {
    const {
      breakpoints
    } = getConfig(theme);
    newScreenSize = 'xs';
    if (breakpoints.sm <= viewport) {
      newScreenSize = 'sm';
    }
    if (breakpoints.md <= viewport) {
      newScreenSize = 'md';
    }
    if (breakpoints.lg <= viewport) {
      newScreenSize = 'lg';
    }
    if (breakpoints.xl <= viewport) {
      newScreenSize = 'xl';
    }
    if (breakpoints.xxl <= viewport) {
      newScreenSize = 'xxl';
    }
  }
  return newScreenSize;
};
const media = (screenSize, theme) => {
  if (typeof theme === 'object' && !(CONF_KEY in theme)) throw new Error('Theme must be a grid config theme.');
  return css`@media ${generateMediaString(screenSize, theme)}`;
};
const mediaBetween = (screenSizeMin, screenSizeMax, theme) => {
  if (typeof theme === 'object' && !(CONF_KEY in theme)) throw new Error('Theme must be a grid config theme.');
  return css`@media ${generateMediaStringBetween(screenSizeMin, screenSizeMax, theme)}`;
};

export { getScreenSize, media, mediaBetween, spacing };
//# sourceMappingURL=layout.js.map
